import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-718dc2fd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "calendar-container" }
const _hoisted_2 = { class: "header-actions" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-content" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "School Calendars"),
  /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, " Manage and organize your school's academic calendar ")
], -1))
const _hoisted_4 = { class: "header-controls" }
const _hoisted_5 = { class: "sort-controls" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "name" }, "Sort by Name", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "startDate" }, "Sort by Start Date", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "endDate" }, "Sort by End Date", -1))
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 0,
  class: "error-message"
}
const _hoisted_11 = {
  key: 1,
  class: "loading"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Loading calendars...", -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 2,
  class: "empty-state"
}
const _hoisted_15 = { class: "empty-state-content" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "No Calendars Found", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Get started by creating your first school calendar", -1))
const _hoisted_18 = {
  key: 3,
  class: "calendar-list"
}
const _hoisted_19 = { class: "calendar-header" }
const _hoisted_20 = { class: "calendar-details" }
const _hoisted_21 = { class: "calendar-date-range" }
const _hoisted_22 = {
  key: 0,
  class: "calendar-description"
}
const _hoisted_23 = { class: "calendar-academic-year" }
const _hoisted_24 = { class: "calendar-actions" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 4,
  class: "modal-overlay"
}
const _hoisted_28 = { class: "modal-content" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Confirm Delete", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "warning" }, "This action cannot be undone.", -1))
const _hoisted_31 = { class: "modal-actions" }
const _hoisted_32 = {
  key: 5,
  class: "modal-overlay"
}
const _hoisted_33 = { class: "modal-content" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Copy Calendar", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Select schools to copy the calendar to:", -1))
const _hoisted_36 = {
  key: 0,
  class: "loading"
}
const _hoisted_37 = {
  key: 1,
  class: "school-list"
}
const _hoisted_38 = ["id", "value"]
const _hoisted_39 = ["for"]
const _hoisted_40 = {
  key: 2,
  class: "error-message"
}
const _hoisted_41 = { class: "modal-actions" }
const _hoisted_42 = ["disabled"]
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 1 }

import { ref, reactive, onMounted, watch, computed } from "vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import axios from "axios";
import { API_URL } from "../config";
import { getErrorMessage } from "../types";
import type { CalendarRecord, OrganizationRecord } from "../types";

// State

export default /*#__PURE__*/_defineComponent({
  __name: 'CalendarView',
  setup(__props) {

const calendars = ref<CalendarRecord[]>([]);
const loading = ref(true);
const error = ref("");
const showDeleteModal = ref(false);
const calendarToDelete = ref<CalendarRecord | null>(null);
const showCopyCalendarModal = ref(false);
const calendarToCopy = ref<CalendarRecord | null>(null);
const availableSchools = ref<OrganizationRecord[]>([]);
const loadingSchools = ref(false);
const selectedSchools = ref<number[]>([]);
const isCopying = ref(false);

// Add new state for sort
const sortBy = ref("name");
const sortOrder = ref("asc");

// Filters
const filters = reactive({
  type: "",
  academicYear: "",
  status: "active",
});

// Add computed property for filtered and sorted calendars
const filteredCalendars = computed(() => {
  let result = [...calendars.value];

  // Apply sorting
  result.sort((a, b) => {
    let comparison = 0;
    switch (sortBy.value) {
      case "name":
        comparison = a.name.localeCompare(b.name);
        break;
      case "startDate":
        comparison =
          new Date(a.startDate).getTime() - new Date(b.startDate).getTime();
        break;
      case "endDate":
        comparison =
          new Date(a.endDate).getTime() - new Date(b.endDate).getTime();
        break;
    }
    return sortOrder.value === "asc" ? comparison : -comparison;
  });

  return result;
});

// Format date function
const formatDate = (dateString: string): string => {
  if (!dateString) return "N/A";

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "Invalid Date";

  // Adjust for timezone offset
  const userTimezoneOffset = date.getTimezoneOffset() * 60000;
  const adjustedDate = new Date(date.getTime() + userTimezoneOffset);

  return adjustedDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

// Functions
const fetchCalendars = async () => {
  loading.value = true;
  try {
    const response = await axios.get(`${API_URL}/calendar`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    // Remove the filter to show all calendars
    calendars.value = response.data;
  } catch (err: unknown) {
    error.value = getErrorMessage(err, "Failed to fetch calendars");
    console.error("Error fetching calendars:", err);
  } finally {
    loading.value = false;
  }
};

const confirmDelete = (calendar: CalendarRecord) => {
  calendarToDelete.value = calendar;
  showDeleteModal.value = true;
};

const deleteCalendar = async () => {
  if (!calendarToDelete.value) return;

  try {
    console.log(
      `Attempting to delete calendar: ${calendarToDelete.value.name} (ID: ${calendarToDelete.value.id})`
    );

    await axios.delete(`${API_URL}/calendar/${calendarToDelete.value.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    console.log("Calendar deleted successfully");

    // Remove from local list
    calendars.value = calendars.value.filter(
      (c) => c.id !== calendarToDelete.value.id
    );

    // Close modal
    showDeleteModal.value = false;
    calendarToDelete.value = null;
  } catch (err: unknown) {
    console.error("Error deleting calendar:", err);
    error.value = getErrorMessage(
      err,
      "Failed to delete calendar. Please try again."
    );

    // Keep the modal open if there's an error
    showDeleteModal.value = true;
  }
};

// Fetch available schools for copying
const fetchSchools = async () => {
  loadingSchools.value = true;
  try {
    const response = await axios.get(`${API_URL}/organizations`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });

    // Filter out the source school
    availableSchools.value = response.data.filter(
      (school: OrganizationRecord) =>
        school.id !== calendarToCopy.value?.school?.id
    );
  } catch (err: unknown) {
    console.error("Error fetching schools:", err);
    error.value = "Failed to load schools";
  } finally {
    loadingSchools.value = false;
  }
};

const openCopyModal = async (calendar: CalendarRecord) => {
  calendarToCopy.value = calendar;
  selectedSchools.value = [];
  showCopyCalendarModal.value = true;
  await fetchSchools();
};

const copyCalendar = async () => {
  if (!calendarToCopy.value || selectedSchools.value.length === 0) return;

  isCopying.value = true;
  error.value = "";

  try {
    const response = await axios.post(
      `${API_URL}/calendar/${calendarToCopy.value.id}/copy`,
      { schoolIds: selectedSchools.value },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    console.log("Calendar copied successfully:", response.data);

    // Refresh calendars list
    await fetchCalendars();

    // Close modal and reset state
    showCopyCalendarModal.value = false;
    calendarToCopy.value = null;
    selectedSchools.value = [];
  } catch (err: unknown) {
    console.error("Error copying calendar:", err);
    error.value = getErrorMessage(err, "Failed to copy calendar");
  } finally {
    isCopying.value = false;
  }
};

// Keep only sort-related methods
const sortCalendars = () => {
  // The computed property will automatically update
};

const toggleSortOrder = () => {
  sortOrder.value = sortOrder.value === "asc" ? "desc" : "asc";
};

// Watch for filter changes
watch(
  filters,
  () => {
    fetchCalendars();
  },
  { deep: true }
);

// Lifecycle hooks
onMounted(() => {
  fetchCalendars();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((sortBy).value = $event)),
            onChange: sortCalendars
          }, _hoisted_9, 544), [
            [_vModelSelect, sortBy.value]
          ]),
          _createElementVNode("button", {
            class: "btn-sort",
            onClick: toggleSortOrder
          }, [
            _createVNode(_unref(FontAwesomeIcon), {
              icon: sortOrder.value === 'asc' ? 'arrow-up' : 'arrow-down'
            }, null, 8, ["icon"])
          ])
        ]),
        _createVNode(_component_router_link, {
          to: "/calendar/add",
          class: "btn-add"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(FontAwesomeIcon), { icon: "plus" }),
            _createTextVNode(" Add Calendar ")
          ]),
          _: 1
        })
      ])
    ]),
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(error.value), 1))
      : _createCommentVNode("", true),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
      : (filteredCalendars.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_unref(FontAwesomeIcon), {
                icon: "calendar",
                class: "empty-state-icon"
              }),
              _hoisted_16,
              _hoisted_17,
              _createVNode(_component_router_link, {
                to: "/calendar/add",
                class: "btn-add"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(FontAwesomeIcon), { icon: "plus" }),
                  _createTextVNode(" Create First Calendar ")
                ]),
                _: 1
              })
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_18, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCalendars.value, (calendar) => {
              return (_openBlock(), _createElementBlock("div", {
                key: calendar.id,
                class: "calendar-card"
              }, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("h2", null, _toDisplayString(calendar.name), 1),
                  _createElementVNode("span", {
                    class: _normalizeClass(["calendar-status", calendar.status])
                  }, _toDisplayString(calendar.status), 3)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("p", _hoisted_21, _toDisplayString(formatDate(calendar.startDate)) + " - " + _toDisplayString(formatDate(calendar.endDate)), 1),
                  (calendar.description)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(calendar.description), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("p", _hoisted_23, " Academic Year: " + _toDisplayString(calendar.academicYear), 1)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_router_link, {
                    to: `/calendar/${calendar.id}`,
                    class: "btn-view"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(FontAwesomeIcon), { icon: "eye" }),
                      _createTextVNode(" View Details ")
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createVNode(_component_router_link, {
                    to: `/calendar/${calendar.id}/events`,
                    class: "btn-view"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(FontAwesomeIcon), { icon: "calendar" }),
                      _createTextVNode(" View Events ")
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createVNode(_component_router_link, {
                    to: `/calendar/${calendar.id}/edit`,
                    class: "btn-edit"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(FontAwesomeIcon), { icon: "edit" }),
                      _createTextVNode(" Edit ")
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  (calendar.type === 'school')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn-copy",
                        onClick: ($event: any) => (openCopyModal(calendar))
                      }, [
                        _createVNode(_unref(FontAwesomeIcon), { icon: "copy" }),
                        _createTextVNode(" Copy ")
                      ], 8, _hoisted_25))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    class: "btn-delete",
                    onClick: ($event: any) => (confirmDelete(calendar))
                  }, [
                    _createVNode(_unref(FontAwesomeIcon), { icon: "trash" }),
                    _createTextVNode(" Delete ")
                  ], 8, _hoisted_26)
                ])
              ]))
            }), 128))
          ])),
    (showDeleteModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("p", null, " Are you sure you want to delete the calendar \"" + _toDisplayString(calendarToDelete.value?.name) + "\"? ", 1),
            _hoisted_30,
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("button", {
                class: "btn-cancel",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (showDeleteModal.value = false))
              }, " Cancel "),
              _createElementVNode("button", {
                class: "btn-confirm-delete",
                onClick: deleteCalendar
              }, " Delete ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (showCopyCalendarModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _hoisted_35,
            (loadingSchools.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, " Loading available schools... "))
              : (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableSchools.value, (school) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: school.id,
                      class: "school-item"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        id: 'school-' + school.id,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedSchools).value = $event)),
                        value: school.id
                      }, null, 8, _hoisted_38), [
                        [_vModelCheckbox, selectedSchools.value]
                      ]),
                      _createElementVNode("label", {
                        for: 'school-' + school.id
                      }, _toDisplayString(school.name), 9, _hoisted_39)
                    ]))
                  }), 128))
                ])),
            (error.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(error.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("button", {
                class: "btn-cancel",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (showCopyCalendarModal.value = false))
              }, " Cancel "),
              _createElementVNode("button", {
                class: "btn-confirm",
                onClick: copyCalendar,
                disabled: selectedSchools.value.length === 0 || isCopying.value
              }, [
                (isCopying.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_43, "Copying..."))
                  : (_openBlock(), _createElementBlock("span", _hoisted_44, "Copy Calendar"))
              ], 8, _hoisted_42)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})